export const INITIAL_TOP = 95; // hardcoded distance from top of the page to component start - used for sticky headers
export const VERTICAL_DIVIDER_WIDTH = 4;
export const FOOTER_HEIGHT = 45;
export const FOOTER_LEFT_SCROLLBAR_PADDING = 4;
export const GRID_CONTAINER_ID = "bookingModuleScrollableContainer";
export const GRID_RIGHT_SUBGRID_ID = "bookingModuleRightPaneScrollable";
export const SPAN_COLUMN_KEY = "span";
export const ROOT_COLUMN_KEY = "root";
